import axios from "axios";
import CreateGetVesselsAction from "./CreateGetVesselsAction";


export default function (licenceApplicationId, vesselId, paymentAmount) {
    return (dispatch) => {

        const newPaymentConfirmationDetail = {
            licenceApplicationId: Number(licenceApplicationId) || 0,
            created: new Date(),
            vesselId: Number(vesselId) || 0,
            paymentAmount: paymentAmount
        };

        axios({
            method: "post",
            url: "api/Payment/PaymentSuccess",
            data: newPaymentConfirmationDetail,
            withCredentials: true
        })
            .then((data) => {
                // Reset amendment payment flag
                dispatch({
                    type: "LICENCE_AMENDMENT",
                    data: false
                });
                
                // Update vessels list
                dispatch(CreateGetVesselsAction(licenceApplicationId));
                alert("Payment Success Complete");
            })
            .catch((error) => {
                alert("Payment Success Error: " + error);
            });
    };
}
